import { memo } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { colors } from '../theme';
import { SvgIconProps } from './SvgIcon.types';

export const LocationPinIcon = memo(({ fontSize = 18, color = colors.basic.black, className, style }: SvgIconProps) => (
  <SvgIcon width="15" height="21" viewBox="0 0 15 21" fill="none" className={className} style={{ fontSize, ...style }}>
    <svg width="15" height="21" viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.32778 0.75C10.9722 0.75 13.9944 3.6463 13.9944 7.13889C13.9944 10.0352 9.46111 17.3611 7.86111 19.6611C7.77222 19.8315 7.50556 19.9167 7.32778 19.9167C7.06111 19.9167 6.88333 19.8315 6.79444 19.6611C5.19444 17.2759 0.75 10.0352 0.75 7.0537C0.75 3.56111 3.68333 0.75 7.32778 0.75Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.32797 10.2907C9.19464 10.2907 10.7058 8.84258 10.7058 7.05369C10.7058 5.2648 9.19464 3.81665 7.32797 3.81665C5.46131 3.81665 3.9502 5.2648 3.9502 7.05369C3.9502 8.84258 5.5502 10.2907 7.32797 10.2907Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
));
